var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"warning","size":"mini"},on:{"click":_vm.showImportBox}},[_vm._v(_vm._s(_vm.buttonName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }